export default __webpack_public_path__ + "imgs/toKnow01.9427bb4.jpeg";